import React from 'react';
import './ValuesQ2.scss';
import ValuesQuestion from '../shared/ValuesQuestion.jsx'
const locator = require('./Locator_1.png')

const definitelyPic = require('./Def_orange.png')
const probablyPic = require('./Prob_orange.png')
const doesntMatterPic = require('./DsntMatter_orange.png')
const probablyNotPic = require('./ProbNot_orange.png')
const definitelyNotPic = require('./DefNot_orange.png')

const definitelyDesktopPic = require('./desktop/Def_orange.png')
const probablyDesktopPic = require('./desktop/Prob_orange.png')
const doesntMatterDesktopPic = require('./desktop/DsntMatter_orange.png')
const probablyNotDesktopPic = require('./desktop/ProbNot_orange.png')
const definitelyNotDesktopPic = require('./desktop/DefNot_orange.png')

const ValuesQ2 = ({ answer, setAnswer, lexicon, answersLexicon, studyId }) => {

  return (
    <div id="ValuesQ2">
        <ValuesQuestion 
          question="q2"
          answer={answer} 
          setAnswer={setAnswer} 
          lexicon={lexicon} 
          answersLexicon={answersLexicon} 
          definitelyPic={definitelyPic} 
          probablyPic={probablyPic} 
          doesntMatterPic={doesntMatterPic} 
          probablyNotPic={probablyNotPic} 
          definitelyNotPic={definitelyNotPic} 
          definitelyDesktopPic={definitelyDesktopPic} 
          probablyDesktopPic={probablyDesktopPic} 
          doesntMatterDesktopPic={doesntMatterDesktopPic} 
          probablyNotDesktopPic={probablyNotDesktopPic} 
          definitelyNotDesktopPic={definitelyNotDesktopPic} 
          backPath="/values-q1"
          nextPath="/values-q3"
          locator={locator}
          studyId={studyId}
        />
    </div>
  );
}

export default ValuesQ2 ;
